import React, {useState} from 'react'
import '../App.css'

function SelectOption({label, id, options}) {

  const[value, setValue] = useState(0)
  const handleChange = (e) =>{
    setValue(e.target.value)
  }

  return (
    <div className='input-field-container'>
      <label htmlFor={id} className='label'>{label}</label>
      <select 
        value={value} 
        id={id} 
        className='select-option'
        onChange={handleChange}>
        {options.map((item, index) => <option key={index} value={index}>{item}</option>)}
      </select >
    </div>
  )
}

export default SelectOption
